import { Link } from "react-router-dom";
import { Globe, AppWindow, Palette, MessageSquare, Megaphone, Bot, ArrowRight } from "lucide-react";
import { Section, SectionHeader, PrimaryButton } from "@/components/Section";
import { SEO } from "@/components/SEO";
import { services } from "@/config/site";

const icons = { Globe, AppWindow, Palette, MessageSquare, Megaphone, Bot };

export default function ServicesHub() {
    return (
        <>
            <SEO title="Usługi – Szymkas Agency" description="Strony internetowe, aplikacje, branding, social media, marketing i automatyzacje AI dla firm." />
            <section className="bg-[#06111F] text-white pt-32 pb-16 md:pt-40 md:pb-24 relative overflow-hidden">
                <div className="absolute inset-0 bg-grid-faint opacity-50" />
                <div className="relative max-w-5xl mx-auto px-5 md:px-8 text-center">
                    <div className="text-xs font-semibold tracking-widest uppercase text-[#14B8A6] mb-3">Nasze usługi</div>
                    <h1 className="font-display font-extrabold text-[38px] md:text-[58px] lg:text-[68px] leading-[1.05] tracking-tight">
                        Wszystko, czego potrzebuje<br />
                        <span className="text-[#14B8A6]">Twoja marka w internecie</span>
                    </h1>
                    <p className="mt-6 text-[#AAB6C5] text-base md:text-lg max-w-2xl mx-auto">
                        Łączymy technologię, design i marketing w jeden spójny system, który realnie wspiera rozwój Twojej firmy.
                    </p>
                </div>
            </section>
            <Section variant="light">
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                    {services.map((s) => {
                        const Icon = icons[s.icon] || Globe;
                        return (
                            <Link key={s.slug} to={`/${s.slug}`} className="group rounded-[20px] bg-white border border-[#E5E7EB] p-7 transition-all hover:-translate-y-1 hover:shadow-[0_24px_50px_-20px_rgba(20,184,166,0.25)] hover:border-[#14B8A6]/40" data-testid={`services-hub-${s.slug}`}>
                                <div className="w-12 h-12 rounded-xl bg-[#14B8A6]/10 text-[#14B8A6] flex items-center justify-center mb-5 group-hover:bg-[#14B8A6] group-hover:text-white transition-colors">
                                    <Icon className="w-6 h-6" />
                                </div>
                                <h3 className="font-display font-semibold text-xl mb-2 text-[#0B1220]">{s.title}</h3>
                                <p className="text-[#0B1220]/70 text-[15px] leading-relaxed">{s.short}</p>
                                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#14B8A6] group-hover:gap-2.5 transition-all">
                                    Dowiedz się więcej <ArrowRight className="w-4 h-4" />
                                </span>
                            </Link>
                        );
                    })}
                </div>
                <div className="mt-12 text-center">
                    <PrimaryButton to="/kontakt" testid="services-hub-cta">Umów bezpłatną konsultację</PrimaryButton>
                </div>
            </Section>
        </>
    );
}
